(function (angular) {
    "use strict";
    angular.module('smartpublic.config').config(RouteConfig);

    RouteConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    function RouteConfig($stateProvider, $urlRouterProvider) {
        $stateProvider.state('404', {
            url: '/404.html',
            templateUrl : '404.html'
        });

		$stateProvider.state('montepio', {
			url : '/montepio',
			abstract : true,
			template : '<div ui-view=""></div>',
			ncyBreadcrumb : {
				label : 'smartpublic'
			}
		}).state('montepio.complaints', {
			url : '/contactos',
			templateUrl : 'core/complaintsform/complaintsform.html',
			controller : 'ComplaintsformController',
			controllerAs : 'ctrl'
		}).state('montepio.providers', {
			url : '/redemedica',
			templateUrl : 'core/providers/providers.html',
			controller : 'ProvidersController',
			controllerAs : 'ctrl'
		}).state('montepio.politics', {
			url : '/politicas',
			templateUrl : 'core/sub-pages/politicas.html'
		}).state('montepio.termsConditions', {
			url : '/termosCondicoes',
			templateUrl : 'core/sub-pages/termosCondicoes.html'
		}).state('montepio.authorize', {
			url : '/autorizo',
			templateUrl : 'core/sub-pages/autorizo.html'
		});

        function getWizardData(factory) {
            return factory.getWizardData().then(
                function (data) {
                    return data;
                }, function () {
                    return $q.reject();
                }
            );
        }


        $urlRouterProvider.otherwise("/montepio/contactos");
    }


})(angular);